import {Component, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatDialog} from '@angular/material/dialog';
import {CategoryDeleteComponent} from './category-delete/category-delete.component';

import {FaqService, SnackbarService} from 'src/app/services';
import {Category} from 'src/app/models';

@Component({
    selector: 'app-question-create',
    templateUrl: './category-popup.component.html',
    styleUrls: ['./category-popup.component.scss']
})
export class CategoryPopupComponent implements OnInit {
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    categories: Category[] = [];
    duplicate = false;
    addOnBlur = true;
    selectedChip = false;
    removable = true;
    selectable = true;

    constructor(private questionService: FaqService,
                private snackbarService: SnackbarService,
                private dialog: MatDialog) {
    }

    ngOnInit() {
        this.getCategories();
    }

    getCategories() {
        this.questionService.getCategories().subscribe(categories => this.categories = categories);
    }

    add(event: any, chipName): void {
        const createdCategory: Category = {questions: [], name: ''};
        if (chipName === 'categoryControl') {
            if (event.target.value) {
                this.duplicate = false;
                createdCategory.name = event.target.value.trim();
                this.questionService.createCategory(createdCategory).subscribe({
                    next: () => {
                        this.getCategories();
                        this.snackbarService.openSnackBar('Successfully added new Category', false);
                    }, error: () => {
                        this.duplicate = true;
                        this.snackbarService.openSnackBar('Could not add new Category', true);
                    }
                });
                event.target.value = '';
            }
        }
    }

    remove(category: Category, controlName): void {
        if (controlName === 'categoryControl') {
            const popupDialog = this.dialog.open(CategoryDeleteComponent, {
                width: '85%',
                data: category
            });
            popupDialog.afterClosed().subscribe(result => {
                if (result) {
                    this.questionService.deleteCategory(category.id).subscribe({
                        next: () => {
                            this.getCategories();
                            this.snackbarService.openSnackBar('Successfully deleted Category', false);
                        }, error: () => {
                            this.snackbarService.openSnackBar('Category NOT Deleted', false);
                        }
                    });
                }
            });
        }
    }
}
